function InlineTextDelimiter() {
    return <span className="px-1">·</span>;
}

export default InlineTextDelimiter;
